import { IGuardianParceiro } from '@/interfaces/Guardian/IGuardianParceiro';
import GuardianService from '@/services/GuardianService'
import Vue from 'vue'
import { VAutocomplete } from 'vuetify/lib'

export const SelectPartner = Vue.component('SelectPartner', {
	name: 'SelectPartner',
	props: {
        franchiseId: {
			type: Number,
			required: true
		}
    },
    data: () => ({
        partnerId: null as null | number,
        partnerList: [] as IGuardianParceiro[]
    }),

    render() {
        return(
            <div>
                <VAutocomplete
                    itemValue="id"
                    itemText="nome"
                    vModel={this.partnerId}
                    items={this.partnerList}
                    class="ma-0"
                    placeholder="Selecione o parceiro"
                />
            </div>
        )
    },

    watch: {
        franchiseId: {
            async handler() {
                this.partnerId = null,
                this.partnerList = new Array()

                if(this.franchiseId > 0)
				    this.partnerList = await GuardianService.getAllPartnersByFranchising(this.franchiseId)
			}
        },
		partnerId: {
			handler() {
				this.$emit('partnerChange', this.partnerId)
			}
		}
	},
})